// @flow
export const FilterTypes = Object.freeze({
    MULTI_SELECT: 'MULTI_SELECT',
    BOOLEAN: 'BOOLEAN',
    RANGE: 'RANGE',
    TIME_RANGE: 'TIME_RANGE'
});

export const FieldPaths = Object.freeze({
    VISIT_LAT: 'v2.customerVisit.chosenLocation.latLng.lat',
    VISIT_LNG: 'v2.customerVisit.chosenLocation.latLng.lng',
    TOUR_LAT: 'summary.centroid.lat',
    TOUR_LNG: 'summary.centroid.lng',
    TASK_ID: 'taskId',
    ALTERNATE_TASK_ID: 'sourceOrderId',
    TASK: 'taskGraph.task',
    SKILLS: 'taskGraph.skills.tags',
    TOUR_ID: 'tourId',
    RIDER: 'taskGraph.rider',
    VEHICLE: 'taskGraph.vehicle',
    RATING: 'taskGraph.rating',
    CUSTOMER_NAME: 'v2.customerVisit.chosenLocation.contact.name',
    CUSTOMER_NUMBER: 'v2.customerVisit.chosenLocation.contact.number',
    CUSTOMER_ADDRESS:
        'v2.customerVisit.chosenLocation.locationAddress.formattedAddress',
    CUSTOMER_ADDRESS_VERIFIED:
        'v2.customerVisit.chosenLocation.geocodingMetadata.verified',
    SLOT_START: 'v2.customerVisit.transactionInfo.slot.current.start',
    SLOT_END: 'v2.customerVisit.transactionInfo.slot.current.end',
    PRIORITY: 'taskGraph.taskPriority',
    TRANSACTION_DURATION:
        'v2.customerVisit.transactionInfo.transactionDuration',
    WEIGHT: 'v2.customerVisit.resources.weight.value',
    VOLUME: 'v2.customerVisit.resources.volume.value',
    PINCODE: 'v2.customerVisit.chosenLocation.locationAddress.pincode',
    LOCATION_ID: 'v2.customerVisit.chosenLocation.locationAddress.id',
    PLACE_NAME: 'v2.customerVisit.chosenLocation.locationAddress.placeName',
    LOCALITY: 'v2.customerVisit.chosenLocation.locationAddress.localityName',
    CITY: 'v2.customerVisit.chosenLocation.locationAddress.city',
    STATE: 'v2.customerVisit.chosenLocation.locationAddress.state',
    TRANSACTION_TYPE:
        'v2.customerVisit.transactionInfo.amountTransaction.exchangeType',
    HOMEBASE: 'v2.homebaseVisit.chosenLocation.locationAddress.id',
    ZONE: 'v2.customerVisit.routeId.routeId',
    SUMMARY_TOUR_ID: 'tourId.tourId',
    SUMMARY_TOUR_NAME: 'tourName',
    SUMMARY_TASK_COUNT: 'summary.taskCount',
    SUMMARY_FREIGHT_COST: 'summary.freightCost.amount',
    SUMMARY_TOTAL_TARDINESS: 'summary.totalTardiness',
    SUMMARY_TOTAL_TRAVEL_DURATION: 'summary.totalTravelDuration',
    SUMMARY_TRANSACTION_DURATION: 'summary.totalTransactionDuration',
    ZONE_ROUTE: 'summary.usedRoutes',
    SUMMARY_IDLE_TIME: 'summary.totalIdleDuration',
    SUMMARY_TOTAL_DURATION: 'summary.totalDuration',
    SUMMARY_TOTAL_DISTANCE: 'summary.totalTravelDistance',
    SUMMARY_SHIFT_START: 'summary.startTime',
    SUMMARY_SHIFT_END: 'summary.endTime',
    CONTRACT_ID: 'contractId.contractId',
    TRANSPORTER_ID: 'transporterId.transporterId',
    LAST_EDITED_ON: 'lastEditedOn',
    ASSIGNED_VEHICLE: 'vehicle.vehicleModel.name',
    AVAILABLE_SKILLS: 'vehicle.skills.tags',
    UTILIZED_SKILLS: 'summary.usedSkills.tags'
});

export const FilterBy = Object.freeze({
    TOUR: 'TOUR',
    VISIT: 'VISIT'
});

export const SortActionTypes = Object.freeze({
    ASC: 'ASC',
    DESC: 'DESC'
});

export const SortOrderSequence = Object.freeze({
    LEXICOGRAPHIC: 'LEXICOGRAPHIC',
    NATURAL: 'NATURAL'
});

export const Containers = Object.freeze({
    Allocated: 'allocated',
    Unallocated: 'unallocated',
    Planned: 'planned',
    UnallocatedMap: 'unallocated_map'
});

export type FilterPath =
    | $Values<typeof FieldPaths>
    | { min: $Values<typeof FieldPaths>, max: $Values<typeof FieldPaths> };

export type ContainerType = $Values<typeof Containers>;
